export const DATA_HOOKS = {
  root: 'private profile disclaimer dialog',
};
